import React, { Component } from 'react';
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import IdleTimer from 'react-idle-timer';
import Header from './scenes/components/Header';
import routes from './routes';
import { isAuthenticated, isLAO } from '../state/reducers/LoginReducer';
import LoginActions from '../state/actions/LoginActions';
import NoMatch from './scenes/NoMatch';
import './App.css';

const RouteWithSubRoutes = (route) => (
  <Route
    path={route.path}
    exact={route.exact}
    render={(props) => {
      // pass the sub-routes down to keep nesting
      if (route.authenticated && route.authRedirect) {
        return (
          <Redirect
            to={{
              pathname: route.authRedirect,
              state: { from: props.location },
            }}
          />
        );
      }
      if (route.authenticated || route.noAuth) {
        return (
          <route.component
            {...{
              ...props,
              ...(typeof route.props === 'function'
                ? route.props(props)
                : route.props),
            }}
            routes={route.routes}
          />
        );
      }
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

class App extends Component {
  onIdle = () => {
    const { isAuthenticated, logout, history } = this.props;
    if (isAuthenticated) logout(history);
  };

  render() {
    const { logout, isLAO, tokenExpired, userInactive } = this.props;
    const isAuthenticated =
      this.props.isAuthenticated && !tokenExpired && !userInactive;
    return (
      <Translation>
        {(t) => {
          return (
            <div>
              <IdleTimer
                element={document}
                onIdle={this.onIdle}
                timeout={
                  1000 * 60 * process.env.REACT_APP_IDLE_TIMER * (isLAO ? 4 : 1)
                }
              />
              <Router>
                <div className="App">
                  <Header logout={logout} authenticated={isAuthenticated} />
                  <Switch>
                    {routes.map((route, i) => (
                      <RouteWithSubRoutes
                        key={i}
                        authenticated={isAuthenticated}
                        {...route}
                      />
                    ))}
                    <Route component={NoMatch} />
                  </Switch>
                </div>
              </Router>
            </div>
          );
        }}
      </Translation>
    );
  }
}

const WithNameSpaces = withTranslation()(App);

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
  isLAO: isLAO(state),
});

const { logoutRequest, setLastActiveTime } = LoginActions;

export default connect(mapStateToProps, {
  logout: logoutRequest,
  setLastActiveTime,
})(WithNameSpaces);



// WEBPACK FOOTER //
// ./src/view/App.js